import { Component, OnInit, ContentChild, TemplateRef, OnDestroy } from '@angular/core';

import { CoreConfigService } from '../../../services/config/core-config.service';
import { OfficeSwitcherService } from '../../../services/service/office-switcher.service';
import { AppSwitcherService } from '../../../services/service/app-switcher.service';

@Component({
    selector: 'zx-office-selector',
    templateUrl: './office-selector.component.html',
    styleUrls: ['./office-selector.component.css'],
    outputs: ['change']
})
export class OfficeSelectorComponent implements OnInit, OnDestroy{

	isModalVisible = false;

    @ContentChild('content', {static:true}) tpl_content: TemplateRef<void>;

	constructor(
		private configService: CoreConfigService,
		private officeSwitcher: OfficeSwitcherService,
        public appSwitcher: AppSwitcherService,
	) {
		
		this.officeSwitcher.registerSelector(this);
	}

	ngOnInit(){ }
	ngOnDestroy(){ }
	

	get canActiveSelector(){
		return this.officeSwitcher.canOpenSelector;
	}
	get communityGroups() : any[] {
		return this.officeSwitcher.currentCommunityGroups;
	}

	get currentOffice(): any{
		return this.officeSwitcher.currentOffice;
	}
	get currentOfficeLevel(): string{
		return this.officeSwitcher.currentOfficeLevel;
	}
	get currentOfficeLevelText(): string{
		return this.officeSwitcher.currentOfficeLevelText;
	}

	get isNonOfficeLevel():boolean{
		return this.currentOfficeLevel==null;
	}

	parseSelectorTitle(): string{
        const text = this.officeSwitcher.currentOfficeLevelText;
        return "切换" + (text||"切换工作区");
	}
	parseOfficeIcon(officeNode: any): string{
		return this.officeSwitcher.parseOfficeIcon(officeNode);
	}
	changeCurrentOffice(office: any){
		this.closeModal();
		this.officeSwitcher.changeCurrentOffice(office);
	}
	openAppSelector() {
        this.closeModal();
        this.appSwitcher.openSelector();
    }
	showModal() {
		if(!this.canActiveSelector) return;
		this.isModalVisible = true;
	}

	closeModal(){
		this.isModalVisible = false;
	}
}